import { Component } from '@angular/core';

export type AdminSubTab = 'ai-usage' | 'audit';

@Component({
  selector: 'app-system-admin',
  templateUrl: './system-admin.component.html',
  styleUrls: ['./system-admin.component.scss'],
})
export class SystemAdminComponent {
  activeTab: AdminSubTab = 'ai-usage';

  setTab(tab: AdminSubTab): void {
    this.activeTab = tab;
  }
}
